const ContentType = {
    TachoMain: 1,

    NotificationList: 44,

    OperationSetting: 2,
        AuthorityManagement: 3,
            MenuPermission: 4,
            PartnerPermission: 5,
        OrganizationManagement: 6,
        AccountManagement: 7,

    CorporateTaxi: 8,
        ClosingDay: 9,
        ClosingDayCommute: 37,
        ClosingMonth: 10,
        ClosingMonthCommute: 38,
        DrivingAggregateDetails: 11,
        DrivingGraphAnalysis: 12,
        DrivingRoute: 13,
        TachoData: 34,
        TachoDataCommute: 39,
        TachoDataPostech: 42,
        TachoDataAndRoute: 52,
        CommuteManagement: 40,
        DrivingDist: 46,

    PrivateTaxi: 14,
        PrivateClosingDay: 15,
        PrivateDrivingAggregateDetails: 16,
        PrivateDrivingGraphAnalysis: 45,
        PrivateDrivingRoute: 17,
        PrivateDrivingData: 36,
        PrivateButtonEvent: 41,

    MasterData: 18,
        DrivingPerMinute: 19,
        ButtonEvent: 20,

    Management: 21,
        AddDevice: 22,
        Company: 23,
        Vehicle: 24,
        Employee: 35,
        LastTransaction: 48,
        DataReq : 50 ,
        DataEzl : 51 ,
    Monitoring: 26
}

export default ContentType
